// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3cvlR","noInteraction":"EventWrapper_noInteraction__1yz6e","pointerPassthrough":"EventWrapper_pointerPassthrough__CclNj"};